<template>
  <section>
    <el-form :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
      <el-form-item prop="mobile">
        <el-input
          size="medium"
          @keyup.enter.native="handleLogin"
          v-model="loginForm.mobile"
          auto-complete="off"
          placeholder="手机号"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <InputSmsCode
        :phone="loginForm.mobile"
        :value="loginForm.captcha"
        @getValue="getValue"
        prop="captcha"
        ref="code"
        :ckickFlag="ckickFlag"
      ></InputSmsCode>
      <p class="text-gray text-left h6 mt2">未注册的手机号验证后自动创建DCI账户</p>
      <el-form-item class="mt6">
        <el-button
          class="btn-login"
          type="primary"
          @click.native.prevent="handleLogin()"
          :disabled="loginFlag"
        >注册/登录</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { phoneNo } from "@/common/regex";
import InputSmsCode from "./inputSmsCode";
let msgBox = null;
export default {
  components: { InputSmsCode },
  data() {
    return {
      passwordType: "password",
      loginFlag:false,
      ckickFlag:true,
      loginForm: {
        mobile: "",
        captcha: ""
      },
      loginRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: phoneNo, message: "请输入正确的手机号码", trigger: "blur" }
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  computed: {},
  methods: {
    getValue(value) {
      this.loginForm.captcha = value;
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          let params = {
            ...this.loginForm
          }
          const res =  await this.$store.dispatch('user/LOGINCAPTCHA',params)
          if (res.code === 200 && res.data) {
            console.log('========打印一下内容',window._czc) 
            this.loginFlag = true
            let self = this 
            self.$router.push("/home")
            if( res.data.new_customer ) window._czc.push(["_trackEvent",'访客来源','注册登录'])
            // this.$message.success("登录成功").onClose = () => {
            //   self.$router.push("/home");
            // };
          }
        }
      });
    },
    clearValidate() {   
      this.$refs.loginForm.resetFields();
      this.$refs.code.changeCode()     
    }
  }
};
</script>

<style scoped>
</style>
